import { atom, selector } from 'recoil'

export const pageState = atom({
  key: 'workflowPageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    isEditingExistingWorkflow: false, // Existing workflow: true; New workflow: false;
    isDirty: false,
    WelcomeMsgEnabled: false,
    isPecPlus: false,
    edit: false,
    saveAndExit: false
  }
})

export const wizardSteps = atom({
  key: 'workflowWizardState',
  default: {
    wizardStep: 0,
    wizardStepsDone: 0
  }
})

export const wizardEnableStep1State = selector({
  key: 'WorkflowWizardEnableStep1State',
  get: () => {
    return true
  }
})

export const wizardEnableStep2State = selector({
  key: 'WorkflowWizardEnableStep2State',
  get: ({ get }) => {
    const { wizardStepsDone } = get(wizardSteps)

    return wizardStepsDone >= 1
  }
})

export const wizardEnableStep3State = selector({
  key: 'WorkflowWizardEnableStep3State',
  get: ({ get }) => {
    const { wizardStepsDone } = get(wizardSteps)

    return wizardStepsDone >= 2
  }
})

export const wizardEnableStep4State = selector({
  key: 'WorkflowWizardEnableStep4State',
  get: ({ get }) => {
    const { wizardStepsDone } = get(wizardSteps)

    return wizardStepsDone >= 3
  }
})

export const wizardEnableStep5State = selector({
  key: 'WorkflowWizardEnableStep5State',
  get: ({ get }) => {
    const { wizardStepsDone } = get(wizardSteps)

    return wizardStepsDone >= 4
  }
})
